module.exports = __webpack_public_path__ + "img/logo52NguyenSinhCung.1c322a11.jpg";